import $ from 'jquery';


export default () => {

  const $menuItem = $('.header--navigation > li[data-menu-id]');
  const $subMenu = $('.header--navigation--sub-container');

  $subMenu.hide();

  if($menuItem.length > 0) {

    /*$menuItem.on('mouseover', function() {
      const $menuID = $(this).data('menu-id');
      $('#'+$menuID).addClass('open');
    });*/

    $menuItem.hover(
      function() {
        $subMenu.stop().slideDown(100);
      },
      function () {
        $subMenu.stop().slideUp(100);
      }
    );

  }

  /*$('.header--navigation--sub-container').on('mouseover', function() {
    $(this).addClass('open');
  });

  $('.header--navigation--sub-container').mouseout(function() {
    $(this).removeClass('open');
  });*/



}



// WEBPACK FOOTER //
// ./assets/js/modules/navigation.js